import { Component, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, TranslationModel, ProductModel, FillingProductModel } from "../models/product";
import {
    IncludedProducts,
    QuantityCalculationResultModel
} from "../models/QuanityCalculatorCast";
import calculatorService from "../services/CalculatorService";
import { EventBus } from "@/events";
import cart from "../services/Cart";
import GoogleEnhancedEcommerce from "../services/GoogleEnhancedEcommerce";

@Component
export default class QuantityCalculatorUBlockProduct extends Vue {
    protected vm!: any;
    protected quantity: number = 1;
    protected calculatedSack: number = 0;
    protected results: QuantityCalculationResultModel[] = [];
    protected translations: TranslationModel;
    protected selectedResult: QuantityCalculationResultModel = calculatorService.GetDefaultQuantityCalculatorResultModel();
    protected products: IncludedProducts[] = [];
    protected selectedProductId: string = "";
    protected isMobile: boolean = false;
    protected noProductSelectedHeader: string = "";
    protected noProductSelectedText: string = "";
    protected title: string = "";
    protected text: string = "";
    protected isPartOfSection: boolean = false;
    protected length?: number = undefined;
    protected isIsolated: boolean = true;
    protected isConcreted: boolean = true;
    protected fillingQuantityResults: QuantityCalculationResultModel[] = [];
    protected fillingQuantityResultsForSession: QuantityCalculationResultModel[] = [];
    protected insulationQuantityResults: QuantityCalculationResultModel[] = [];
    protected italicFontObject: object = {} as object;
    protected italicFont: string = "italic";
    private readonly googleAnalyticsDimensionIdentifier: string;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
        this.googleAnalyticsDimensionIdentifier = "ProductPage";
    }

    protected created() {
        this.noProductSelectedHeader = this.$attrs.noproductselectedheader;
        this.noProductSelectedText = this.$attrs.noproductselectedtext;
        this.products = this.$attrs.includedproducts
            ? JSON.parse(this.$attrs.includedproducts)
            : null;
        this.isMobile = this.$attrs.ismobile === "true";
        this.title = this.$attrs.title;
        this.text = this.$attrs.text;
        this.selectedProductId = "";
        this.length = undefined;
        this.calculatedSack = 0;

        this.italicFontObject = { "font-style": this.italicFont, "font-size": "13px" };
    }

    protected mounted() {
        EventBus.$on("calculateQuantityOnProductChange", (selectedId: string) => {
            this.selectedProductId = selectedId;
            this.calculateQuantity();
        });
    }

    protected close() {
        this.$emit("close", true);
        const quantityInput = document.getElementById(
            "variant-selector-quantity"
        );
        if (quantityInput) {
            quantityInput.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
    }

    get selectedProductUrl(): string {
        return calculatorService.GetSelectedProductUrl(this.products, this.selectedProductId);
    }

    get product(): ProductModel {
        return productStore.product;
    }

    get variant(): Variant {
        return productStore.variant;
    }

    get variants(): Variant[] {
        return calculatorService.GetVariants(this.selectedProductId, this.products);
    }

    get showIsolatedOptions(): boolean {
        return this.variant.insulationVariantModel && this.variant.insulationVariantModel !== null;
    }

    get isOnlyShoppingList(): boolean {
        return productStore.product.isOnlyShoppingList;
    }

    protected radiobuttonchanged() {
        this.resetCalculatedQuantities();
        this.calculateQuantity();
    }

    protected measurementChanged() {
        this.resetCalculatedQuantities();
        this.calculateQuantity();
    }

    protected resetCalculatedQuantities() {
        this.results = [];
        this.insulationQuantityResults = [];
        this.fillingQuantityResults = [];
        this.fillingQuantityResultsForSession = [];
    }

    protected calculateQuantity() {
        this.results = [];
        this.selectedResult = calculatorService.GetDefaultQuantityCalculatorResultModel();
        this.calculatedSack = 0;

        if (this.variant.itemConsumptionCalculatorUBlock && this.length) {
            if (this.length > 0) {
                this.results.push({
                    variantId: this.variant.variantId,
                    sack: Math.ceil(this.length * this.variant.itemMaterialConsumption),
                    itemPackagingWeight: NaN,
                    selected: (this.variant.variantId === this.variant.variantId).toString(),
                    volume: NaN,
                    selectedShape: "",
                    yta: NaN,
                    layerThickness: NaN,
                    itemMaterialConsumption: this.variant.itemMaterialConsumption,
                    variantJoint: "",
                    width: NaN,
                    length: NaN,
                    depth: NaN,
                    variantSystemId: this.variant.variantSystemId
                });
            }
        }

        this.calculateInsulationItemsQuantity();
        this.calculateFillingItemsQuantity();

        if (this.results.length > 0) {
            const selectedVariant = this.results.filter(x => x.variantId === this.variant.variantId)[0];
            this.calculatedSack = selectedVariant.sack;
            this.selectedResult = selectedVariant;
            if (selectedVariant != null) {
                productStore.dispatchQuantity(selectedVariant.sack);
            }
        }
    }

    protected calculateInsulationItemsQuantity() {
        if (this.isIsolated === true && this.variant.insulationVariantModel && this.variant.insulationVariantModel.id && this.length) {
            if (this.variant.insulationVariantModel.packagingLength) {

                this.insulationQuantityResults.push({
                    variantId: this.variant.insulationVariantModel.id,
                    sack: Math.ceil((this.length / this.variant.insulationVariantModel.packagingLength) * 1000),
                    itemPackagingWeight: NaN,
                    selected: "",
                    volume: NaN,
                    selectedShape: "",
                    yta: NaN,
                    layerThickness: NaN,
                    itemMaterialConsumption: this.variant.itemMaterialConsumption,
                    variantJoint: "",
                    width: NaN,
                    length: NaN,
                    depth: NaN,
                    variantSystemId: this.variant.insulationVariantModel.variantSystemId
                });

                calculatorService.storeSession("ublockinsulationquantity", this.insulationQuantityResults);
            }
        }
    }

    protected calculateFillingItemsQuantity() {
        if (this.isConcreted) {
            this.variant.fillingProductModel.map(x => {
                x.fillingVariantModel.map(y => {
                    let weight;

                    if (this.length && (!this.showIsolatedOptions || (this.showIsolatedOptions && this.isIsolated !== true))) {
                        weight = this.length * this.variant.itemAdditionalMaterialConsumption;
                    } else if (this.length && this.showIsolatedOptions && this.isIsolated === true) {
                        weight = this.length * this.variant.itemFillingWithInsulation;
                    }

                    const sacks = weight ? Math.ceil(weight / y.packagingWeight) : 0;

                    if (!this.fillingQuantityResults.some(a => a.itemPackagingWeight === y.packagingWeight)) {
                        this.fillingQuantityResults.push({
                            variantId: y.id,
                            sack: sacks,
                            itemPackagingWeight: y.packagingWeight,
                            selected: "",
                            volume: NaN,
                            selectedShape: "",
                            yta: NaN,
                            layerThickness: NaN,
                            itemMaterialConsumption: NaN,
                            variantJoint: "",
                            width: NaN,
                            length: NaN,
                            depth: NaN,
                            variantSystemId: y.variantSystemId,
                        });
                    }

                    if (!this.fillingQuantityResultsForSession.some(a => a.itemPackagingWeight === y.packagingWeight && a.variantId === y.id)) {
                        this.fillingQuantityResultsForSession.push({
                            variantId: y.id,
                            sack: sacks,
                            itemPackagingWeight: y.packagingWeight,
                            selected: "",
                            volume: NaN,
                            selectedShape: "",
                            yta: NaN,
                            layerThickness: NaN,
                            itemMaterialConsumption: NaN,
                            variantJoint: "",
                            width: NaN,
                            length: NaN,
                            depth: NaN,
                            variantSystemId: y.variantSystemId,
                        });
                    }
                });
            });

            calculatorService.storeSession("ublockfillingquantity", this.fillingQuantityResultsForSession);
        }
    }

    protected addToCart() {
        let variantSystemIds: string = "";
        if (this.results.length > 0 && this.results[0].sack > 0) {
            cart.addToCartWithSingleAddedToCart({
                quantity: this.results[0].sack,
                variantId: this.results[0].variantId,
                variantSystemId: this.results[0].variantSystemId
            }, {} as Element);
            this.ReportAddToCartToGoogleEnhancedEcommerce(this.results[0].variantId, this.results[0].sack);
            variantSystemIds = variantSystemIds + "," + this.results[0].variantSystemId;
        }

        if (this.insulationQuantityResults.length > 0 && this.insulationQuantityResults[0].sack > 0) {
            cart.addToCartWithSingleAddedToCart({
                quantity: this.insulationQuantityResults[0].sack,
                variantId: this.insulationQuantityResults[0].variantId,
                variantSystemId: this.insulationQuantityResults[0].variantSystemId
            }, {} as Element);
            this.ReportAddToCartToGoogleEnhancedEcommerce(this.insulationQuantityResults[0].variantId, this.insulationQuantityResults[0].sack);
            variantSystemIds = variantSystemIds + "," + this.insulationQuantityResults[0].variantSystemId;
        }

        if (this.fillingQuantityResults.length > 0 && this.fillingQuantityResults[0].sack > 0) {
            cart.addToCartWithSingleAddedToCart({
                quantity: this.fillingQuantityResults[0].sack,
                variantId: this.fillingQuantityResults[0].variantId,
                variantSystemId: this.fillingQuantityResults[0].variantSystemId
            }, {} as Element);
            this.ReportAddToCartToGoogleEnhancedEcommerce(this.fillingQuantityResults[0].variantId, this.fillingQuantityResults[0].sack);
            variantSystemIds = variantSystemIds + "," + this.fillingQuantityResults[0].variantSystemId;
        }

        if (window.eventBus) {
            EventBus.$emit("productAddedToCartMultipleVariants", variantSystemIds, window.site.settings.webShopActivated === "true");
        }
    }

    private ReportAddToCartToGoogleEnhancedEcommerce(variantId: string, quantity: number) {
        const variant = this.variants.filter(x => x.variantId === variantId);
        if (variant && variant.length > 0) {
            const gee = new GoogleEnhancedEcommerce();
            gee.PushAddToCartToGoogle(
                variant[0].variantName,
                variant[0].variantId,
                variant[0].priceValue,
                variant[0].category,
                quantity,
                this.googleAnalyticsDimensionIdentifier,
                variant[0].currencyCode,
                window.site.settings.activateProductWebshop ? true : false,
            );
        }
    }
}
